import script from "./ButtonGift.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonGift.vue?vue&type=script&setup=true&lang=js"

import "./ButtonGift.vue?vue&type=style&index=0&id=1457f85e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1457f85e"]])

export default __exports__